/**
 * Единые русские подписи слотов образа (OutfitSlot на бэкенде: BASE/MID/OUTER/BOTTOM/FOOTWEAR/
 * ACCESSORY). Один источник для подбора дня, виджета главной, детали образа, каталога
 * сохранённых образов и конструктора — раньше каждая страница держала свою копию, и «Внешний
 * слой»/«Верхний слой», «Аксессуар»/«Аксессуары» расходились между экранами (QA-11).
 */
export const SLOT_LABELS: Record<string, string> = {
    BASE: 'Базовый слой',
    MID: 'Средний слой',
    OUTER: 'Верхний слой',
    BOTTOM: 'Низ',
    FOOTWEAR: 'Обувь',
    ACCESSORY: 'Аксессуар',
};

/** Порядок слотов сверху вниз — для сортировки вещей образа. */
export const SLOT_ORDER = ['BASE', 'MID', 'OUTER', 'BOTTOM', 'FOOTWEAR', 'ACCESSORY'];

/**
 * Подпись слота вещи: слот образа приоритетнее названия слоя вещи (`layerName` — атрибут
 * многослойности, а не роль в образе: у очков он даёт «Базовый слой»). Без слота и слоя — пусто.
 */
export function slotLabel(slot: string | null | undefined, layerName?: string | null): string {
    if (slot && SLOT_LABELS[slot]) return SLOT_LABELS[slot];
    if (slot) return slot;
    return layerName ?? '';
}

/** Индекс слота для сортировки; неизвестные слоты — в конец. */
export function slotRank(slot: string | null | undefined): number {
    const idx = slot ? SLOT_ORDER.indexOf(slot) : -1;
    return idx < 0 ? SLOT_ORDER.length : idx;
}
